import React from "react";
import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import CsvSvg from "../../../../assets/svg/csv.svg";
import EditIcon from "../../../../assets/svg/edit.svg";

import styles from "./extra-info-actions.module.scss";

interface Props {
  onCopy: () => void;
  onExport: () => void;
  editUrl: string;
}

const ExtraInfoActions: React.FC<Props> = ({ onCopy, onExport, editUrl }) => {
  return (
    <>
      <Tooltip title="Copy vehicle extra-info" placement="top">
        <button onClick={onCopy} className={`but but-white-gray but-xsm ${styles.copyButton}`} type="button">
          Copy
        </button>
      </Tooltip>

      <Tooltip title="Export CSV" placement="top">
        <button onClick={onExport} className={styles.iconButton}>
          <img src={CsvSvg} alt="CSV" />
        </button>
      </Tooltip>

      <Tooltip title="Edit vehicle extra-info" placement="top">
        <Link to={editUrl} className={styles.iconButton}>
          <img src={EditIcon} alt="Edit" />
        </Link>
      </Tooltip>
    </>
  );
};

export default ExtraInfoActions;
